/* eslint-disable eqeqeq */
import { orderBy } from 'lodash';
import { convHasUnreadMessages } from '../utils/messaging';

export function resolveSelectedConv(state, incomingConvs) {
    if (state.newConversation) {
        return undefined;
    }
    if (state.selectedConv) {
        return state.selectedConv;
    }
    if (incomingConvs?.length) {
        return incomingConvs[0].id;
    }
    return null;
}

export function shouldShowUnreadNotification(conv, selectedConvId, inboxIsOpen) {
    if (!convHasUnreadMessages(conv)) {
        return false;
    }
    return !(inboxIsOpen && conv.id == selectedConvId);
}

export function hasAnyUnreadConv(convs, selectedConvId, inboxIsOpen) {
    return convs.some(conv => shouldShowUnreadNotification(conv, selectedConvId, inboxIsOpen));
}

export function mergeIncomingConvs(existingConvs, incomingConvs, selectedConvId, inboxIsOpen) {
    const updatedConvs = [];
    let headerUnreadNotification = false;
    incomingConvs.forEach(incoming => {
        const match = existingConvs.find(c => c.id === incoming.id);
        if (match) {
            const existingIds = new Set(match.messages.map(m => m.id));
            const mergedMessages = [...match.messages, ...incoming.messages.filter(m => !existingIds.has(m.id))];
            updatedConvs.push({
                ...match,
                messages: orderBy(mergedMessages, 'created', 'desc'),
            });
        } else {
            updatedConvs.push(incoming);
        }
        if (shouldShowUnreadNotification(incoming, selectedConvId, inboxIsOpen)) {
            headerUnreadNotification = true;
        }
    });
    return { convs: updatedConvs, headerUnreadNotification };
}
